// extracted by mini-css-extract-plugin
module.exports = {"item":"accordion_item__yHGia","trigger":"accordion_trigger__s8JoF","content":"accordion_content__43ExO"};